var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.08984H3.33333C2.59333 2.08984 2 2.68984 2 3.42318V12.7565C2 13.4898 2.59333 14.0898 3.33333 14.0898H12.6667C13.4 14.0898 14 13.4898 14 12.7565V4.75651L11.3333 2.08984ZM12.6667 12.7565H3.33333V3.42318H10.78L12.6667 5.30984V12.7565ZM8 8.08984C6.89333 8.08984 6 8.98318 6 10.0898C6 11.1965 6.89333 12.0898 8 12.0898C9.10667 12.0898 10 11.1965 10 10.0898C10 8.98318 9.10667 8.08984 8 8.08984ZM4 4.08984H10V6.75651H4V4.08984Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f89fc77d3c7d6f3caaa41a2f6593d387.svg";
export { ForwardRef as ReactComponent };